import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { CompanyCode } from '../../constants/company-code';
import { SalesDistrict } from '../../constants/sales-district';
import { CosmosCustomer } from '../../models/customer';
import { LoadingPanelComponent } from '../loading-panel';

@Component({
  selector: 'ntw-customer-service-dialog',
  templateUrl: './customer-service-dialog.component.html',
  styleUrls: ['./customer-service-dialog.component.scss'],
  imports: [ButtonModule, LoadingPanelComponent, DialogModule, TranslateModule]
})
export class CustomerServiceDialogComponent implements OnInit, OnDestroy {
  @Input() public close: () => void;
  @Input() public customer: CosmosCustomer;

  public loading = true;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.renderer.addClass(this.document.body, 'no-scroll');
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'no-scroll');
  }

  public isAlcroCustomer() {
    const salesDistrict = this.customer.SalesDistrict;
    return salesDistrict && salesDistrict.startsWith(SalesDistrict.AlcroSweden)
  }

  public isBeckersCustomer() {
    const salesDistrict = this.customer.SalesDistrict;
    return salesDistrict && salesDistrict.startsWith(SalesDistrict.BeckersSweden)
  }

  public isNorwayCustomer() {
    const companyCode = this.customer.TikkurilaCompanyRegisterCode;
    return companyCode === CompanyCode.Norway;
  }
}
